"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_ROLE_ARN_RE = exports.modelSmithServiceTokenTypes = exports.aiServiceTokenTypes = exports.selectableServiceTokenTypes = exports.apiTokenServiceTokenTypes = exports.AuthTypes = exports.RoleBasedPermissionType = exports.PermissionType = exports.Permissions = exports.GoogleCredentialUsageScope = exports.DirectoryKind = exports.AwsCredentialKind = exports.GoogleCredentialKind = exports.CredentialView = void 0;
const serviceToken_1 = require("./api/serviceToken");
var CredentialView;
(function (CredentialView) {
    CredentialView["Public"] = "public";
    CredentialView["Run"] = "run";
    CredentialView["UserOwned"] = "userOwned";
})(CredentialView || (exports.CredentialView = CredentialView = {}));
var GoogleCredentialKind;
(function (GoogleCredentialKind) {
    GoogleCredentialKind["KeyFile"] = "key_file";
    GoogleCredentialKind["ImpersonationServiceAccount"] = "impersonation_sa";
})(GoogleCredentialKind || (exports.GoogleCredentialKind = GoogleCredentialKind = {}));
var AwsCredentialKind;
(function (AwsCredentialKind) {
    AwsCredentialKind["StaticKey"] = "static_key";
    AwsCredentialKind["AssumeRole"] = "assume_role";
})(AwsCredentialKind || (exports.AwsCredentialKind = AwsCredentialKind = {}));
var DirectoryKind;
(function (DirectoryKind) {
    DirectoryKind["Work"] = "work";
    DirectoryKind["Download"] = "download";
    DirectoryKind["Publish"] = "publish";
})(DirectoryKind || (exports.DirectoryKind = DirectoryKind = {}));
var GoogleCredentialUsageScope;
(function (GoogleCredentialUsageScope) {
    GoogleCredentialUsageScope["Dataset"] = "dataset";
    GoogleCredentialUsageScope["Run"] = "run";
    GoogleCredentialUsageScope["Cortex"] = "cortex";
})(GoogleCredentialUsageScope || (exports.GoogleCredentialUsageScope = GoogleCredentialUsageScope = {}));
var Permissions;
(function (Permissions) {
    Permissions[Permissions["UserOwned"] = 3] = "UserOwned";
    Permissions[Permissions["GroupShared"] = 15] = "GroupShared";
    Permissions[Permissions["Public"] = 63] = "Public";
    Permissions[Permissions["SpecificUsersShared"] = 42] = "SpecificUsersShared";
})(Permissions || (exports.Permissions = Permissions = {}));
var PermissionType;
(function (PermissionType) {
    PermissionType["UserOwned"] = "userOwned";
    PermissionType["Shared"] = "shared";
    PermissionType["GroupShared"] = "groupShared";
    PermissionType["Public"] = "public";
    PermissionType["Admin"] = "admin";
    PermissionType["UserOwnedAndGroupShared"] = "userOwnedAndGroupShared";
    PermissionType["NonOwnerGroupShared"] = "nonOwnerGroupShared";
    PermissionType["Default"] = "default";
    PermissionType["OrgAdmin"] = "orgAdmin";
    PermissionType["NonAdminDefault"] = "nonAdminDefault";
    PermissionType["SpecificUsersShared"] = "specificUsersShared";
})(PermissionType || (exports.PermissionType = PermissionType = {}));
var RoleBasedPermissionType;
(function (RoleBasedPermissionType) {
    RoleBasedPermissionType["UserOwned"] = "userOwned";
    RoleBasedPermissionType["Shared"] = "shared";
    RoleBasedPermissionType["GroupShared"] = "groupShared";
    RoleBasedPermissionType["Public"] = "public";
    RoleBasedPermissionType["Admin"] = "admin";
    RoleBasedPermissionType["UserOwnedAndGroupShared"] = "userOwnedAndGroupShared";
})(RoleBasedPermissionType || (exports.RoleBasedPermissionType = RoleBasedPermissionType = {}));
var AuthTypes;
(function (AuthTypes) {
    AuthTypes["Google"] = "google";
    AuthTypes["Local"] = "local";
    AuthTypes["Github"] = "github";
    AuthTypes["SAML"] = "saml";
    AuthTypes["LDAP"] = "ldap";
})(AuthTypes || (exports.AuthTypes = AuthTypes = {}));
exports.apiTokenServiceTokenTypes = [
    serviceToken_1.ServiceTokenType.Github,
    serviceToken_1.ServiceTokenType.Gitlab,
    serviceToken_1.ServiceTokenType.OpenAI,
    serviceToken_1.ServiceTokenType.BaseSpace,
    serviceToken_1.ServiceTokenType.Gemini,
    serviceToken_1.ServiceTokenType.Anthropic,
    serviceToken_1.ServiceTokenType.GoogleCloud,
];
exports.selectableServiceTokenTypes = [
    serviceToken_1.ServiceTokenType.OpenAI,
    serviceToken_1.ServiceTokenType.Gemini,
    serviceToken_1.ServiceTokenType.Anthropic,
];
exports.aiServiceTokenTypes = [
    serviceToken_1.ServiceTokenType.OpenAI,
    serviceToken_1.ServiceTokenType.Gemini,
    serviceToken_1.ServiceTokenType.Anthropic,
];
exports.modelSmithServiceTokenTypes = [serviceToken_1.ServiceTokenType.GoogleCloud];
exports.AWS_ROLE_ARN_RE = /^arn:aws:iam::\d{12}:role\/[\w+=,.@/-]+$/;
